import { useQuery } from "./useApi";
import { approvalRequests } from "../api/approvalRequests.service";

export function useApprovalRequest(id: string | undefined) {
  return useQuery(() => {
    if (!id) throw new Error("ID is required");
    return approvalRequests.getById(id);
  }, [id]);
}
